module.exports = __webpack_public_path__ + "mobile/img/huiTalk-img2.171bfee9.png";